import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import Pagination from '../../common/pagination'
import Spinner from '../../common/spinner-container'
import ExperienceRecord from './experience-record'
import { useExperienceScreen } from './use-experience-screen'
import EmptyList from './empty-list'

const ExperiencesList = () => {

    const { offset, setOffset, limit, total, courses, isBusy } = useExperienceScreen();

    const renderItem = (item) => (<ExperienceRecord key={item.id} experience={item} />)
    const renderItems = () => courses.length ? courses.map(renderItem) : (<EmptyList />)

    if (isBusy) {
        return (<div><Spinner /></div>)
    }

    return (
        <Container>
            <Row>
                <Col className='experiences-table'>
                    {renderItems(courses)}
                </Col>
            </Row>
            <Row>
                <Col>
                    <Pagination
                        offset={offset}
                        setOffset={setOffset}
                        total={total}
                        limit={limit}
                    />
                </Col>
            </Row>
        </Container>
    )
}

export default ExperiencesList